import Decorator from './decorator'
import accounting from 'accounting'

export default class CreditNoteItemDecorator extends Decorator {
  currencyAmount () {
    return accounting.formatMoney(this.decorated.amount)
  }
}



// WEBPACK FOOTER //
// ./src/decorators/credit-note-item.js